export default __webpack_public_path__ + "static/media/emoji-money.8c7e4fd9.svg";